import * as ng from 'angular';
import { ComponentRegistration } from '../../core';
import { ISessionService } from '../../services';
let template = require('./admin.html');

class AdminComponent extends ComponentRegistration {

    constructor() {
        super('admin', {
            controller: AdminController,
            templateUrl: template,
            controllerAs: 'admin',
            $routeConfig: [
                { path: '/dashboard', component: 'dashboard', name: 'Dashboard', useAsDefault: true },
                { path: '/accounts/...', component: 'accounts', name: 'Accounts' },     
                { path: '/pending-approval', component: 'pendingApproval', name: 'PendingApproval' },        
                { path: '/pending-approval/:id', component: 'pendingApproval', name: 'SelectedPendingApproval' },
                { path: '/setup/...', component: 'setup', name: 'Setup' },
                { path: '/users', component: 'users', name: 'Users' }
            ],
            bindings: {
            }
        });
    }
}

interface IAdminController {
}

class AdminController implements IAdminController {
    private static $inject: Array<string> = ['$rootRouter', 'Session'];

    constructor(private $rootRouter: ng.Router,
        private Session: ISessionService) {
        console.log('AdminController loading');
    
    }

    public $onInit(): void {
       if (!this.Session.assureActiveUserSession()) {
            
            return;
        }
        console.log('AdminController loaded');
    }
}

let admnComponent = new AdminComponent();
export default admnComponent;
export { admnComponent as AdminComponent, IAdminController, AdminController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/admin.ts